import type { ReactElement, ReactNode } from "react";
import { REGLAGES_RETOUR } from "./reglages-texts";

/**
 * Le cadre des pages de reglages (Overlays, Import) : un lien de retour vers l'index, le titre de la page et son
 * contenu. Les liens sont de simples `<a>` (la regie se monte sans routeur dans ses tests, comme `regie.tsx`).
 */

export const LIEN =
  "text-primary no-underline hover:text-[#FCDD8E] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

/** Un panneau a liseré dore, comme les cartes de La Taverne. */
export const PANNEAU =
  "relative flex flex-col gap-4 rounded-md border-2 border-[var(--lisere)] bg-card px-7 py-6 shadow-[0_6px_0_var(--nuit)]";
/** Une carte du template (`Card`) habillee en panneau Heure doree : le remplissage reste celui de ses en-tete et contenu. */
export const CARTE =
  "rounded-md border-2 border-[var(--lisere)] bg-card text-card-foreground shadow-[0_6px_0_var(--nuit)]";
export const TITRE_CARTE = "police-titre text-[28px] font-normal text-primary";
export const TITRE_PANNEAU = "police-titre m-0 text-[30px] font-normal text-primary";

export function CadreReglages({
  titre,
  children,
}: {
  titre: string;
  children: ReactNode;
}): ReactElement {
  return (
    <div className="police-texte flex flex-col gap-6 text-[22px] md:text-[24px]">
      <a href="/regie/reglages" className={`w-fit text-[20px] ${LIEN}`}>
        {REGLAGES_RETOUR}
      </a>
      <h1 className="police-titre m-0 text-[40px] font-normal text-primary">{titre}</h1>
      {children}
    </div>
  );
}
